import gql from 'graphql-tag'
import { areaSimpleFragment } from 'graphqlAPI/areas/fragments'

export const courseEvaluationDetailFragment = gql`
  fragment CourseEvaluationDetailFragment on CourseEvaluationDetail {
    id
    evaluationName
    required
    minScore
    maxScore
    responded
    approved
    totalScore
    canRestart
  }
`

export const courseUserFragment = gql`
  fragment CourseUserFragment on CourseUser {
    courseId
    userId
    advance
    evaluationsState
    user {
      active
      identifier
      name
      lastname
      position
      avatar
    }
    area {
      ...AreaFragmentSimple
    }
    overallProgress
    assignedLessons
    mandatory
    enrol {
      integrationStatus
    }
    synchronousCourseEvaluations {
      id
      position
      qualification
    }
    synchronousCourseEnrol {
      finalState
      attendance
    }
    liveSessionAttendancePercent
    certificatesCount
    normativeProfileIncomplete
  }
  ${areaSimpleFragment}
`
